import React from 'react';

interface Props {
  children: React.ReactNode;
}
const ConfWrapper: React.FC<Props> = ({ children }) => {

  return (
    <div className="flex-1 min-w-0">
      <div className="mt-5 md:mt-0">
        <div className="px-4 py-3 bg-gray-50 sm:px-6">
          <div className="sm:my-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfWrapper
